import * as React from 'react'
import * as moment from 'moment'
import 'moment/locale/fr'
import {Redirect, Route, Switch, withRouter, RouteComponentProps} from 'react-router'
import Empty from 'src/page/Empty/Empty'
import {fetchAccountInfos} from 'src/core/redux/action/accountInfosAction'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {RootState} from 'src/core/redux/reducer'
import Consumers from 'src/page/Consumers/Consumers'
import Consumer from 'src/page/Consumer/Consumer'
import ValidationTunnel from 'src/page/ValidationTunnel/ValidationTunnel'
import ChangePassword from 'src/page/ChangePassword/ChangePassword'
import autobind from 'autobind-decorator'
import Profile from './page/Consumer/Profile/Profile'
import { HelmetMeta } from './shared/HelmetTitle/HelmetMeta'

interface IProps extends WithI18n,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

class Platform extends React.Component<IProps, {}> {

  componentDidMount(){
    this.props.fetchInfos();
  }

  render() {
    const {connectedUser, t} = this.props
    return (
        <>
        <HelmetMeta title={t.App_title_page_Plateform}/>
        {connectedUser &&
        <Switch>
            <Route path="/ptf/change-password" component={ChangePassword} />
            <Route path="/ptf/profile" component={Profile} />
            <Route path="/ptf/tunnel" component={ValidationTunnel} />
            <Route path="/ptf/enterprise/:key" component={Consumer} />
            {/*
            <Route exact path={["/","","/enterprise"]} render={this.redirect} {...connectedUser} />
            */}
            <Route exact path="/" render={this.redirect} {...connectedUser} />
            <Route exact path="" render={this.redirect} {...connectedUser} />
            <Route exact path="/ptf/enterprise" render={this.redirect} {...connectedUser} />
            <Route component={Empty} />
        </Switch>
        }
        </>
    )
  }

  @autobind
  private redirect(){
    const {connectedUser, location} = this.props
    return connectedUser.last_password_update === undefined ? (<Redirect to="/ptf/tunnel" />) :
            (moment(connectedUser.last_password_update).isBefore(moment().subtract(1, 'year')) ?
              (<Redirect to={ {pathname: "/ptf/change-password", state: {redirectUrl: location.pathname}} }/>) : <Consumers />
    )
  }
}

const state2props = (state: RootState) => ({
  isFetching: state.accountInfo.isFetching,
  connectedUser: state.accountInfo.connectedUser,
  enterprises: state.accountInfo.enterprises
});

const dispatch2props = dispatch => ({
  fetchInfos: () => dispatch(fetchAccountInfos()),
});

export default compose(
  withI18n,
  withRouter,
  connect(state2props, dispatch2props)
)(Platform)



// WEBPACK FOOTER //
// ./src/Platform.tsx